var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cancel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#647084"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M124.5,123.592l2.537-2.537a.642.642,0,1,0-.906-.908l-2.537,2.537-2.537-2.537a.642.642,0,0,0-.908.908l2.537,2.537-2.537,2.537a.642.642,0,1,0,.908.908l2.537-2.537,2.537,2.537a.642.642,0,1,0,.908-.908Z",
    transform: "translate(-115.806 -115.599)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelFilledIcon);
export default __webpack_public_path__ + "static/media/cancel-filled-icon.b0843a6957608b711202adbb5dae63cf.svg";
export { ForwardRef as ReactComponent };